// extracted by mini-css-extract-plugin
export default {"PageFiveBg":"PageFive_PageFiveBg__mL-xQ","pageFiveEditSpace":"PageFive_pageFiveEditSpace__B-QLr","colorPurple":"PageFive_colorPurple__nr1vN","BtnEdit":"PageFive_BtnEdit__LFIi1"};